(function () {
  'use strict';

  let angular = window.angular;

  ProcessLayoutRouter.$inject = ['$stateProvider'];

  angular.module('app').config(ProcessLayoutRouter);

  function ProcessLayoutRouter($stateProvider) {
    $stateProvider
      .state('member.project.scada', {
        url: '/process-layout',
        redirectTo: 'member.project.scada.home',
        template: '<ui-view></ui-view>',
        authenticated: true,
        ncyBreadcrumb: {
          label: 'Process Layout',
        },
        resolve: {
          hasTool: [
            'tools',
            'AppUtils',
            function (tools, utils) {
              const hasTool = tools.find((tool) => tool.module === 'xompassSCADA');
              if (!hasTool) {
                throw utils.getHTTPError(new Error('Not allowed'), {
                  redirectTo: 'member.customer.invalidTool',
                  params: { tool: 'xompassSCADA' },
                });
              }
            },
          ],
          dependencies: [
            '$ocLazyLoad',
            '$rootScope',
            function ($ocLazyLoad, $root) {
              const style = $root.darkMode ? 'dark' : 'light';
              return $ocLazyLoad.load([
                window.assetsPath + '/js/vendors/scada-vendors.min.js',
                window.assetsPath + `/js/vendors/chart-vendors-${style}.min.js`,
              ]);
            },
          ],
          module: [
            '$ocLazyLoad',
            'dependencies',
            function ($ocLazyLoad) {
              return $ocLazyLoad.load([window.assetsPath + '/js/app/scada.module.min.js']);
            },
          ],
        },
      })
      .state('member.project.scada.home', {
        url: '/',
        component: 'scadaHome',
        authenticated: true,
        resolve: {
          scadas: [
            'Customer',
            'Manager',
            '$transition$',
            function (Customer, Manager, $transition$) {
              let params = $transition$.params();
              return Customer.prototype$__get__projects__processLayouts({
                id: Manager.getCachedCurrent().customerId,
                nk: params.projectId,
                filter: { include: ['container'] },
              }).$promise;
            },
          ],
        },
        ncyBreadcrumb: {
          label: '{{"general.gallery" | translate}}',
        },
      })
      .state('member.project.scada.new', {
        url: '/new',
        component: 'scadaEditor',
        authenticated: true,
        ncyBreadcrumb: {
          label: 'New',
        },
      })

      .state('member.project.scada.show', {
        url: '/:scadaId',
        component: 'scadaShow',
        redirectTo: 'member.project.scada.show.viewer',
        authenticated: true,
        resolve: {
          scada: [
            'Customer',
            'Manager',
            '$transition$',
            'AppUtils',
            function (Customer, Manager, $transition$, utils) {
              let params = $transition$.params();
              return loadSCADA(
                Customer,
                Manager.getCachedCurrent().customerId,
                params.projectId,
                params.scadaId,
                utils
              );
            },
          ],
        },
        ncyBreadcrumb: {
          label: '{{$resolve.scada.name}}',
        },
      })

      .state('member.project.scada.show.viewer', {
        url: '/viewer',
        component: 'scadaViewer',
        authenticated: true,
        ncyBreadcrumb: {
          label: 'Viewer',
        },
      })
      .state('member.project.scada.show.editor', {
        url: '/editor',
        component: 'scadaEditor',
        authenticated: true,
        ncyBreadcrumb: {
          label: 'Editor',
        },
      });

    function loadSCADA(Customer, customerId, projectId, scadaId, utils) {
      if (!scadaId) {
        throw utils.getHTTPError(new Error('Process Layout ID required'), {
          redirectTo: 'member.project.scada.home',
          params: { customerId: customerId, projectId: projectId },
        });
      }

      return Customer.prototype$__findById__projects__processLayouts({
        id: customerId,
        nk: projectId,
        fk: scadaId,
      }).$promise.catch((err) => {
        console.log(err);
        throw utils.getHTTPError(err, {
          redirectTo: 'member.project.scada.home',
          params: { customerId: customerId, projectId: projectId },
        });
      });
    }
  }
})();
